"use client";

import { HOME_PAGE } from "@/constants";
import { usePassportProvider } from "@/context";
import { useRouter } from "next/navigation";
import { type ReactNode, useEffect } from "react";

export default function ProtectedLayout({
  children,
}: {
  children: ReactNode;
}) {
  const { isLoggedIn } = usePassportProvider();
  const router = useRouter();

  useEffect(() => {
    if (isLoggedIn === false) {
      router.replace(HOME_PAGE);
    }
  }, [router, isLoggedIn]);

  return <>{children}</>;
}
